import {View} from "@lernetz/ts-lib";
import {gateway} from "../../services/gateway";
import {languageService} from "../../services/lang";
import {trackEvent} from "../../services/tracker";
import template from "./search.html";

export class SearchPage extends View {
    constructor() {
        super({ template });
    }

    init() {
        const el = this.node.querySelector('input#search') as HTMLInputElement;
        this.data.el = el;
        el.focus();
        el.addEventListener('input', (event: InputEvent) => {
            this.data.loading = true;
            this.data.search((event.target as HTMLInputElement).value);
        })
    }
}

export class SearchPageController {
    searchResults: {
        tools: any;
        goodPractices: any;
    };
    currentLang: any;
    loading: boolean;
    el: HTMLInputElement;
    init() {
        this.currentLang = languageService.currentLang;
    }
    search(query) {
        this.loading = true;
        this.debouncedSearch(query);
    }
    overrideSearch(term) {
        this.el.value = term;
        this.search(term);
    }

    test() {
        // debugger;
    }

    debouncedSearch = debounce( (query) => {
        if (query) {
            gateway.search(query).then( res => {
                this.loading = false;
                this.searchResults = res;
                trackEvent('search', { query })
            });
        } else {
            this.searchResults = null;
        }
    })

}


const debouncedTrack = debounce( (query) => {
});

function debounce(func, timeout = 800){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}
